export default __webpack_public_path__ + "static/media/vire24.2f188a23.jpg";